'use client'

import { Tooltip } from 'fukku/Tooltip'
import { IconInfoL } from 'icons/components/IconInfoL'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import { useRef } from 'react'

import { BodyContent } from './BodyContent/BodyContent'

import styles from './ExtraInfo.module.scss'

const MARGIN_TOOLTIP = 8
const DEFAULT_ICON_SIZE = 13

type ExtraInfoProps = {
	iconSize?: number
	numberOfPrices: number
}

export function ExtraInfo({
	iconSize = DEFAULT_ICON_SIZE,
	numberOfPrices,
}: ExtraInfoProps) {
	const containerRef = useRef<HTMLDivElement>(null)

	const { isApp, channel } = useMasterData()
	const { t } = useLabels()

	const boundary = {
		current: {
			getBoundingClientRect: () => ({
				left: 0,
				right:
					(containerRef.current?.getBoundingClientRect()?.right || 0) +
					MARGIN_TOOLTIP,
			}),
		} as HTMLDivElement,
	}

	return !isApp ? (
		<div ref={containerRef}>
			<Tooltip
				id='price-history'
				content={
					<BodyContent
						numberOfPrices={numberOfPrices}
						channel={channel}
						getLabel={t}
					/>
				}
				className={styles.tooltip}
				boundary={boundary}
			>
				<span className={styles.icon}>
					<IconInfoL width={iconSize} height={iconSize} />
				</span>
			</Tooltip>
		</div>
	) : null
}
